import React from 'react';
import ReactDOM from 'react-dom';
import './global.css';
import App from './components/App';
// import ErrorBoundary from './components/ErrorBoundary'

 // ReactDOM.render(<ErrorBoundary><App /></ErrorBoundary>, document.getElementById('root'));
  ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js